import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import PropTypes from 'prop-types';
import _ from 'lodash';

const RowLabelField = (props) => {
  const {
    value, translation, left, right,
  } = props;
  return (
    <Row {...props}>
      <Col xs={left}>
        <label>{ _.isString(translation) ? <Translate value={translation} /> : translation }</label>
      </Col>
      <Col xs={right}>
        <label className="pull-right">{ value }</label>
      </Col>
    </Row>
  );
};

RowLabelField.defaultProps = {
  translation: '',
  value: '',
  left: 6,
  right: 6,
};

RowLabelField.propTypes = {
  translation: PropTypes.node,
  value: PropTypes.node,
  left: PropTypes.number,
  right: PropTypes.number,
};

export default RowLabelField;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/RowLabelField.jsx